import styled from "@emotion/styled";

export const AtlasStyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 100vh;
`;
